import React, { Component, Fragment } from "react";

export default class NovoForm extends Component {

    constructor(props) {
        super(props);

        this.state = { 
            resumoMeta: {}
        }

    }

    render() {
        let { unidade, metas, categoria, indicadoresnome, indicadoresid, metasDaUnidade, formDisabled } = this.props;
        metasDaUnidade = metasDaUnidade && (metasDaUnidade.filter(meta => meta.categoria === categoria)[0]);
        return (
            <Fragment>
                <table style={{marginBottom: "30px"}} id={this.props.id}>
                    <thead>
                        <tr>
                            <th colSpan="13">{categoria}</th>
                        </tr>
                        <tr>
                            <th>Indicador</th>
                            <th scope="col">Jan</th>
                            <th scope="col">Fev</th>
                            <th scope="col">Mar</th>
                            <th scope="col">Abr</th>
                            <th scope="col">Mai</th>
                            <th scope="col">Jun</th>
                            <th scope="col">Jul</th>
                            <th scope="col">Ago</th>
                            <th scope="col">Set</th>
                            <th scope="col">Out</th>
                            <th scope="col">Nov</th>
                            <th scope="col">Dez</th>
                        </tr>
                    </thead>
                    <tbody>
                        {indicadoresnome.map((mes, key) => {
                            return (
                                <tr key={key} className={"formDisabledOrNot"}>
                                    <th scope="row" style={{ textTransform: "capitalize" }} >{mes}</th>
                                    <td scope="col"><input type="value" className={indicadoresid[key]} name={indicadoresid[key]} defaultValue={metasDaUnidade && metasDaUnidade.valores[indicadoresid[key]][0]} disabled={formDisabled} /></td>
                                    <td scope="col"><input type="value" className={indicadoresid[key]} name={indicadoresid[key]} defaultValue={metasDaUnidade && metasDaUnidade.valores[indicadoresid[key]][1]} disabled={formDisabled} /></td>
                                    <td scope="col"><input type="value" className={indicadoresid[key]} name={indicadoresid[key]} defaultValue={metasDaUnidade && metasDaUnidade.valores[indicadoresid[key]][2]} disabled={formDisabled} /></td>
                                    <td scope="col"><input type="value" className={indicadoresid[key]} name={indicadoresid[key]} defaultValue={metasDaUnidade && metasDaUnidade.valores[indicadoresid[key]][3]} disabled={formDisabled} /></td>
                                    <td scope="col"><input type="value" className={indicadoresid[key]} name={indicadoresid[key]} defaultValue={metasDaUnidade && metasDaUnidade.valores[indicadoresid[key]][4]} disabled={formDisabled} /></td>
                                    <td scope="col"><input type="value" className={indicadoresid[key]} name={indicadoresid[key]} defaultValue={metasDaUnidade && metasDaUnidade.valores[indicadoresid[key]][5]} disabled={formDisabled} /></td>
                                    <td scope="col"><input type="value" className={indicadoresid[key]} name={indicadoresid[key]} defaultValue={metasDaUnidade && metasDaUnidade.valores[indicadoresid[key]][6]} disabled={formDisabled} /></td>
                                    <td scope="col"><input type="value" className={indicadoresid[key]} name={indicadoresid[key]} defaultValue={metasDaUnidade && metasDaUnidade.valores[indicadoresid[key]][7]} disabled={formDisabled} /></td>
                                    <td scope="col"><input type="value" className={indicadoresid[key]} name={indicadoresid[key]} defaultValue={metasDaUnidade && metasDaUnidade.valores[indicadoresid[key]][8]} disabled={formDisabled} /></td>
                                    <td scope="col"><input type="value" className={indicadoresid[key]} name={indicadoresid[key]} defaultValue={metasDaUnidade && metasDaUnidade.valores[indicadoresid[key]][9]} disabled={formDisabled} /></td>
                                    <td scope="col"><input type="value" className={indicadoresid[key]} name={indicadoresid[key]} defaultValue={metasDaUnidade && metasDaUnidade.valores[indicadoresid[key]][10]} disabled={formDisabled} /></td>
                                    <td scope="col"><input type="value" className={indicadoresid[key]} name={indicadoresid[key]} defaultValue={metasDaUnidade && metasDaUnidade.valores[indicadoresid[key]][11]} disabled={formDisabled} /></td>
                                </tr>
                            )
                        })}
                    </tbody>
                </table>
                                                
            </Fragment>
        )
    }
}